export class Address {
    street?: string;
    city?: string;
    zip?: string;
    country?: string;
}
